import { MouseEvent, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';
import { Button } from 'antd';
import { PrinterOutlined } from '@ant-design/icons';
import { useGetSampleReportQuery } from 'app/services/samples';
import { Sample } from 'app/services/samples/types';
import PrintSheet from './PrintSheet';
import './print.less';

const Print = ({ sample }: { sample: Sample }) => {
  const { t } = useTranslation();
  const { data, isFetching } = useGetSampleReportQuery(sample.Id);
  const [ printing, setPrinting ] = useState(false);

  useEffect(() => {
    if (!printing) return;

    // window.print() does not block on mobile browsers, so the sheet stays mounted until afterprint
    const handleAfterPrint = () => setPrinting(false);
    window.addEventListener('afterprint', handleAfterPrint);
    document.body.classList.add('printing');
    window.print();

    return () => {
      window.removeEventListener('afterprint', handleAfterPrint);
      document.body.classList.remove('printing');
    };
  }, [ printing ]);

  const handleClick = (event: MouseEvent) => {
    event.stopPropagation();
    setPrinting(true);
  };

  return (
    <>
      <Button size='small' icon={<PrinterOutlined />} loading={isFetching} onClick={handleClick}>
        {t('common.print')}
      </Button>
      {printing && createPortal(<PrintSheet sample={sample} reports={data} />, document.body)}
    </>
  );
};

export default Print;
